<div class="slide-toggle-wrapper" [ngClass]="{'labelOff': labelOff === true}" style='--columns:{{labelWidth}}'>
    <p *ngIf="!labelPosition || labelOff === false" class="slide-toggle__label-text {{labelClasses}}">{{labelText}}</p>
    <mat-slide-toggle
            class="slide-toggle__item {{cssClasses}}"
            [attr.label]="labelOff"
            [tabindex]="tabIndex"
            [disabled]="disabled"
            [aria-label]="ariaLabel"
            [checked]="checked"
            [disableRipple]="true"
            [labelPosition]="labelPosition"
            (change)="slided($event)">
        <ng-container *ngIf="labelPosition || labelOff === false">
            {{labelText}}
        </ng-container>
    </mat-slide-toggle>
</div>
